export default __webpack_public_path__ + "static/media/instagram.c575ed83.jpeg";